/**
 * TypeScript types for Medication Orders
 */

export enum MedicationOrderStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
  ON_HOLD = 'ON_HOLD',
  EXPIRED = 'EXPIRED',
}

export enum MedicationRoute {
  ORAL = 'ORAL',
  IV = 'IV',
  IM = 'IM',
  TOPICAL = 'TOPICAL',
  SUBCUTANEOUS = 'SUBCUTANEOUS',
  INHALATION = 'INHALATION',
  RECTAL = 'RECTAL',
  SUBLINGUAL = 'SUBLINGUAL',
  OTHER = 'OTHER',
}

export interface MedicationItemDTO {
  id?: string;
  medicationOrderId?: string;
  medicationName: string;
  genericName?: string;
  dosage: string;
  route: MedicationRoute;
  frequency: string;
  startDate: string;
  endDate?: string;
  indication?: string;
  specialInstructions?: string;
  sideEffectsToMonitor?: string;
  isPrn?: boolean;
  prnReason?: string;
  pharmacyName?: string;
  pharmacyPhone?: string;
  refillsAuthorized?: number;
  quantity?: string;
  notes?: string;
}

export interface MedicationOrderDTO {
  id?: string;
  orderNumber?: string;
  residentId: string;
  residentName?: string;
  prescribingPhysicianId?: string;
  prescribingPhysicianName: string;
  medicationItems: MedicationItemDTO[];
  startDate?: string;
  endDate?: string;
  status?: MedicationOrderStatus;
  orderedBy?: string;
  orderedAt?: string;
  approvedBy?: string;
  approvedAt?: string;
  discontinuedBy?: string;
  discontinuedAt?: string;
  discontinuationReason?: string;
  notes?: string;
  tenantId?: string;
  facilityId?: string;
  createdAt?: string;
  updatedAt?: string;
  canBeModified?: boolean;
  isActive?: boolean;
}

export interface CreateMedicationOrderRequest {
  residentId: string;
  prescribingPhysicianName: string;
  medicationItems: MedicationItemDTO[];
  startDate?: string;
  endDate?: string;
  notes?: string;
}

export interface PageResponse<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
  first: boolean;
  last: boolean;
  empty: boolean;
}
